module.exports = __webpack_public_path__ + "80d1e9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Sidebar/static/ic_APP_Hover.png
// module id = 946
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16